/* eslint-disable @typescript-eslint/no-explicit-any */
import { usePayAnInvoiceFormData } from "@/store/payAnInvoiceFormsStore";

import AppText from "../other/AppText";
import { format, parseISO } from "date-fns";

import { Amex, Discover, Echeck, MasterCard, Visa } from "@/assets/Icons";
import { CardTypes } from "./constants";
import { useEffect } from "react";
import { StatementLineItemPayment } from "@/types/payments";

const formatDate = (date: string) => {
  const parseDate = parseISO(date);
  const formattedDate = format(parseDate, "MMM dd, yyyy");

  return formattedDate.replace(",", "");
};

const getBalanceAmount = (totalAmount: string, partialAmount: string) => {
  return (Number(totalAmount) - Number(partialAmount)).toFixed(2).toString();
};

const sumOfPayment = (multiplePayments: any) => {
  const paymentArray = Object.values(multiplePayments);
  let sum = 0;
  paymentArray.forEach((item) => {
    sum += Number(item);
  });

  return Number.parseFloat(sum.toString()).toFixed(2).toString();
};

const getPaymentSummaryData = (data: any, invoiceResponse: any, paymentResponse: any, formDataSecondTab: any): any => {
  const heading: string[] = [];
  const values: string[] = [];
  const mobileViewRes: any = [];

  data.forEach((item: { fields: { name: string }[] }, index: number) => {
    if (index == data.length - 1) {
      if (Number(formDataSecondTab.Payment_amount) != Number(invoiceResponse?.STATEMENT_LINES?.item[0].BALANCE)) {
        heading.push(item.fields[0].name);
      }
    } else {
      heading.push(item.fields[0].name);
    }
  });

  const formattedPrice = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: invoiceResponse?.STATEMENT_LINES?.item[0]?.CURRENCY,
  }).format(Number(sumOfPayment(formDataSecondTab.Payment_amount)));

  values.push(
    // `${getCurrencySymbol(invoiceResponse?.STATEMENT_LINES?.item[0])}${Number(formDataSecondTab.Payment_amount)
    //   .toFixed(2)
    //   .toString()}`
    formattedPrice
  );
  values.push(
    paymentResponse?.cardDetails?.cardFullName == CardTypes.EcheckFullName
      ? CardTypes.Echeck
      : paymentResponse?.cardDetails?.cardFullName
  );
  values.push(paymentResponse["ZFI_CC_CS_PAYMENT.Response"].CS_PAYMENT.IN.SUBSCRIPTIONID);
  heading.forEach((item, index) => {
    mobileViewRes.push({
      id: index,
      heading: heading[index],
      values: values[index],
    });
  });

  return mobileViewRes;
};

const getPaymentSummaryforMultipleInvoice = (
  headingData: any,
  selectedInvoice: StatementLineItemPayment,
  formDataSecondTab: { [key: string]: string }
) => {
  const heading: any[] = [];
  const values: any[] = [];
  const responseObj: any = [];

  headingData.forEach((item: any, index: number) => {
    if (index === headingData.length - 1) {
      if (Number(formDataSecondTab.Payment_amount[selectedInvoice?.DOC_NO]) != Number(selectedInvoice?.BALANCE)) {
        heading.push(item.fields[0].name);
      }
    } else {
      heading.push(item.fields[0].name);
    }
  });

  values.push(selectedInvoice?.accountName);
  values.push(selectedInvoice?.billingAdress);
  values.push(selectedInvoice?.siteAdress);
  values.push(selectedInvoice?.LINES.item?.[0].ALLOC_NMBR);
  values.push(selectedInvoice?.DOC_NO);
  values.push(formatDate(selectedInvoice?.DOC_DATE));
  const formattedPrice2 = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: selectedInvoice?.CURRENCY,
  }).format(selectedInvoice?.BALANCE);

  values.push(
    // `${getCurrencySymbol(invoiceResponse?.STATEMENT_LINES?.item[0])}${
    //   invoiceResponse?.STATEMENT_LINES?.item[0].BALANCE
    // }`
    formattedPrice2
  );
  if (Number(formDataSecondTab.Payment_amount[selectedInvoice?.DOC_NO]) != Number(selectedInvoice?.BALANCE)) {
    const formattedPrice3 = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: selectedInvoice?.CURRENCY,
    }).format(
      Number(
        getBalanceAmount(selectedInvoice?.BALANCE.toString(), formDataSecondTab.Payment_amount[selectedInvoice?.DOC_NO])
      )
    );

    values.push(
      // `${getCurrencySymbol(invoiceResponse?.STATEMENT_LINES?.item[0])}${getBalanceAmount(
      //   invoiceResponse?.STATEMENT_LINES?.item[0].BALANCE,
      //   formDataSecondTab.Payment_amount
      // )}`
      formattedPrice3
    );
  }
  heading.forEach((item, index) => {
    responseObj.push({
      id: index,
      heading: heading[index],
      values: values[index],
    });
  });
  return responseObj;
};

const rendercardLogo = (cardType: string) => {
  switch (cardType) {
    case CardTypes.Visa: {
      return <Visa />;
    }
    case CardTypes.AmericanExpress: {
      return <Amex />;
    }
    case CardTypes.MasterCard: {
      return <MasterCard />;
    }
    case CardTypes.Echeck: {
      return <Echeck />;
    }
    case CardTypes.Discovery: {
      return <Discover />;
    }
    default: {
      return <></>;
    }
  }
};

const FormRequestPayAnInvoiceStep4 = ({ formDataTab }: { formDataTab: any }) => {
  const { customerInvoiceResponse, formDataSecondTab, paymentSuccessResponse, selectedInvoicesResponse } =
    usePayAnInvoiceFormData();

  const cardsDetails = `${paymentSuccessResponse?.cardDetails?.cardNumber}${
    paymentSuccessResponse?.cardDetails?.cardExpire
      ? `, ${formDataTab?.groups?.[1]?.rows?.[1].fields[0].text}: ${paymentSuccessResponse?.cardDetails?.cardExpire}`
      : ""
  }`;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <div className="lg:col-span-10 lg:col-start-2 lg:px-10 bg-green col-span-4 px-6 pt-12 mb-24">
        <AppText type="SUB_HEADING_MEDIUM" className="mb-[28px]">
          {formDataTab.groups[1].heading}
        </AppText>
        {getPaymentSummaryData(
          formDataTab.groups[1].rows.slice(0, 3),
          customerInvoiceResponse,
          paymentSuccessResponse,
          formDataSecondTab
        ).map((item: any, index: number) => {
          return (
            <div className="flex flex-col w-full" key={item.id}>
              <div className="flex flex-row flex-1 w-full mb-1">
                <div className=" text-ellipsis lg:basis-1/4 basis-1/2 flex flex-wrap items-center flex-1 overflow-hidden">
                  <AppText type="BODY_SMALL" className={`truncate font-[600] ${index == 0 && `text-16`}`}>
                    {item.heading}
                  </AppText>
                </div>
                <div className="text-ellipsis lg:basis-3/4 basis-1/2 flex items-center flex-1 overflow-hidden">
                  {index == 1 && (
                    <div>
                      {rendercardLogo(paymentSuccessResponse["ZFI_CC_CS_PAYMENT.Response"].CS_PAYMENT.IN.CCINS)}
                    </div>
                  )}
                  <AppText
                    type="BODY_SMALL"
                    className={`truncate font-[400] ${index == 0 && `text-16 font-[600]`} ${
                      index == 10 && `text-[#DE350B]`
                    }`}
                  >
                    {item.values} {index == 1 && cardsDetails}
                  </AppText>
                </div>
              </div>
              {index == 2 && <div className="bg-black-60 broder-[1px] border border-[#CDD2D5] mt-4 mb-4"></div>}
            </div>
          );
        })}
        {selectedInvoicesResponse.map((selectedInvoice: StatementLineItemPayment) => {
          return (
            <>
              {getPaymentSummaryforMultipleInvoice(
                formDataTab.groups[1].rows.slice(3),
                selectedInvoice,
                formDataSecondTab
              ).map((item: any, index: number) => {
                return (
                  <>
                    <div className="flex flex-col w-full" key={item.id}>
                      <div className="flex flex-row flex-1 w-full mb-1">
                        <div className=" text-ellipsis lg:basis-1/4 basis-1/2 flex flex-wrap items-center flex-1 overflow-hidden">
                          <AppText type="BODY_SMALL" className={`truncate font-[400] `}>
                            {item.heading}
                          </AppText>
                        </div>
                        <div className="text-ellipsis lg:basis-3/4 basis-1/2 flex items-center flex-1 overflow-hidden">
                          <AppText
                            type="BODY_SMALL"
                            className={`truncate font-[400]  ${index == 7 && `text-[#DE350B]`}`}
                          >
                            {item.values}
                          </AppText>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
              <div className="bg-black-60 broder-[1px] border border-[#CDD2D5] mt-4 mb-4"></div>
            </>
          );
        })}
      </div>
    </>
  );
};
export default FormRequestPayAnInvoiceStep4;
